import { TextField } from '@mui/material';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AIDuplicateTrainedModel } from '../@shared/Models/Models';
import { ModalBase } from '../components/ModalBase';
import { closeDuplicateModelModalAction, createDuplicateModelAction } from '../sagas/trainedModelSaga/trainedModelSagaActions';
import { getIsShowDuplicateModelModal, getDuplicateModelId } from '../reducers/trainedModel/trainedModelReducer';
import { InputBaseSx } from '../@shared/templates';

export const withDuplicateTrainedModel = <T extends Record<string, unknown>>(
  Component: React.ComponentType<T>
): React.FC<T> => (props) => {
  const [name, setName] = React.useState<string>("");
  const [description, setDescription] = React.useState<string>("");

  const dispatch = useDispatch();
  const handleClose = () => dispatch(closeDuplicateModelModalAction())

  const isOpen = useSelector(getIsShowDuplicateModelModal);
  const trainedModelId = useSelector(getDuplicateModelId);

  const onSave = () => {
    dispatch(createDuplicateModelAction({
      name: name,
      description: description,
      id: trainedModelId
    } as AIDuplicateTrainedModel))
  }

  const onChangeName = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setName(e.target.value);
  }

  const onChangeDescription = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setDescription(e.target.value)
  }

  return <>
    <ModalBase
      isOpen={isOpen}
      onCancel={handleClose}
      onSave={onSave}
      title="Duplicate"
      description="Create a copy of the selected model, including its schema and training settings, without affecting the original model.
Useful for experimenting with changes or training a new version while keeping the old one intact."
    >
      <TextField size="small" fullWidth sx={{ ...InputBaseSx, marginBottom: "10px" }} disabled value={trainedModelId} className='' label="Id" variant="outlined" />
      <TextField size="small" fullWidth sx={{ ...InputBaseSx, marginBottom: "10px" }} value={name} onChange={onChangeName} className='' label="Name" variant="outlined" />
      <TextField size="small" fullWidth sx={{ ...InputBaseSx }} value={description} onChange={onChangeDescription} className='' label="Description" variant="outlined" />
    </ModalBase>
    <Component {...props as T} />
  </>
}